<script setup>
/**
 * PageEditorDetachFromPageBtn
 * Disconnects a content record from the current page layout.
 * Logic:
 * - Only visible in 'pageEditor' mode for 'content' tables.
 * - Hidden for global areas (Header/Footer) to prevent accidental detachment of site-wide layout elements.
 */
import { computed, getCurrentInstance } from 'vue';
import FormSidebarBtn from "./FormSidebarBtn.vue";

const props = defineProps({
    formId: {
        type: String,
        required: true
    }
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- Computed ---

const formState = computed(() => store.state[props.formId]);

const tableName = computed(() => formState.value?.tableName);

const isPageEditor = computed(() => proxy.$route.name === 'pageEditor');

const pageEditorState = computed(() => store.state.pageEditor);

const pageContentId = computed(() => pageEditorState.value?.activePageContentId);

const pageContent = computed(() => {
    return pageEditorState.value?.contentItems.find(o => o.pageContentId === pageContentId.value);
});

const isHeaderOrFooterContent = computed(() => {
    const area = pageContent.value?.contentAreaName;
    return area === 'Page header' || area === 'Page footer';
});

const show = computed(() => {
    return (
        isPageEditor.value &&
        tableName.value === 'content' &&
        !isHeaderOrFooterContent.value
    );
});

// --- Methods ---

const onClick = () => {
    store.dispatch('pageEditor/detachContent', pageContentId.value);
};
</script>

<template>
    <FormSidebarBtn
        v-if="show"
        class="text-warning-emphasis"
        @click.prevent.native="onClick"
    >
        <i class="me-2 bi bi-x-lg"/>
        Detach from page
    </FormSidebarBtn>
</template>